var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 277,
    viewBox: "0 0 203 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.526 81.8089L31.069 118.587L36.5885 137.567L163.046 100.789L157.526 81.8089Z",
    fill: "#26920E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.47 239.53L181.215 239.603C181.429 239.708 181.557 239.837 181.601 239.99C182.228 242.189 163.461 249.496 139.673 256.28C115.884 263.064 96.0863 266.757 95.4591 264.557L44.3752 135.339L155.297 103.078L181.47 239.53Z",
    fill: "#F5C15F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 38.7339L2.73478 48.1297L50.279 52.8203L85.5692 102.741L94.2947 100.197L53.5859 43.5265L0 38.7339Z",
    fill: "#60C676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.805 173.589L70.5734 201.604L61.0848 177.618L164.027 148.259L168.805 173.589Z",
    fill: "#60C676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.28 173.429C153.288 154.464 137.145 139.875 118.223 140.843C99.3009 141.811 84.7656 157.97 85.7574 176.935C86.7491 195.899 102.892 210.488 121.814 209.52C140.736 208.552 155.272 192.393 154.28 173.429Z",
    fill: "#063F2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.439 163.452C127.093 175.678 127.075 183.223 127.984 187.572C132.349 184.632 138.584 179.093 136.438 172.405C133.214 162.393 136.294 156.169 136.294 156.169C108.777 167.482 124.096 189.861 124.096 189.861C124.096 189.861 124.229 190.007 124.785 189.701C122.929 174.875 131.155 163.81 131.439 163.452Z",
    fill: "#59C47B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.748 175.076C109.748 175.076 117.855 181.004 121.013 193.174C116.631 192.248 107.62 189.601 107.721 183.249C107.848 174.862 102.158 172.448 102.158 172.448C102.158 172.448 110.866 168.103 119.091 175.343C124.543 180.148 124.639 186.609 124.071 190.421C121.512 184.865 116.606 176.494 109.748 175.076Z",
    fill: "#59C47B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.a92ed759d763b89cea8b1c382c3a051a.svg";
export { ForwardRef as ReactComponent };